import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager

} from "react-native";
import ReactDOM from 'react-dom';

//const mediaRecorder=null;
export default class HMLabel extends Component {

    constructor(props) {
        super(props);
        this.mediaRecorder = null;
        this.state = {
            mediaRecorder: {},
            isRecording: false,
            // value: 'احمد'
        }
    }


    componentWillReceiveProps(props) {


    }

    createDownloadLink = url => {
        const link = <a href={url} download="Recording.mp4">Download</a>;
        const linkContainer = document.getElementById('download-link');
        ReactDOM.render(link, linkContainer);
    }

    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);

      //  this.initializeMediaRecorder();
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    /**
     * Start recording the stream
     */
    start = async () => {
        if (this.mediaRecorder.state === 'recording') return;
        this.mediaRecorder.start();
        this.setState({
            isRecording: true
        })
    }

    /**
     * Stop recording the stream
     */
    stop = async () => {
        if (this.mediaRecorder.state === 'inactive') return;
        this.mediaRecorder.stop();
        this.setState({
            isRecording: fa
        })
        await this.initializeMediaRecorder();
    }

    /**
     * Set the playback player's source to the url of the newly recorderd stream
     * @param {string} url
     */
    // setPlaybackPreview = url => {
    //     if (!playerRef.current) return;
    //     console.log(`Playback URL: ${url}`);
    //     playerRef.current.src = url;
    // }

    /**
     * Get a media device stream (webcam)
     */
    getStream = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: {
                        facingMode: 'user'
                    }
                });
                console.log('Stream fetched');
                resolve(stream);
            }
            catch (err) {
                console.log('Error in fetching stream')
                reject(err);
            }
        })
    }

    /**
     * Set the live stream retrieved from the media device
     * to the designated player to preview
     * @param {object} stream
     */
    setRecordingStreamPreview = stream => {
        if (!this.recorderRef.current) return;
        this.recorderRef.current.srcObject = stream;
    }

    /**
     * Create MediaRecorder object from a given stream
     * @param {object} stream
     */
    createMediaRecorder = stream => {
        return new Promise((resolve, reject) => {
            try {
                this.mediaRecorder = new MediaRecorder(stream);
                console.log('New MediaRecorder created');
                resolve(this.mediaRecorder);
            }
            catch (err) {
                console.log('Error in creating new MediaRecorder');
                reject(err);
            }
        })
    }

    /**
     * Initialize MediaRecorder
     */
    initializeMediaRecorder = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                const stream = await this.getStream();
                this.setRecordingStreamPreview(stream);
                const mediaRecorder = await this.createMediaRecorder(stream);
                this.setState({mediaRecorder: mediaRecorder},
                    () => {
                       // alert("fghf")
                        let chunks = [];

                        this.mediaRecorder.ondataavailable = e => chunks.push(e.data)

                        this.mediaRecorder.onstop = e => {
                            let blob = new Blob(chunks, {type: 'video/mp4'});
                            chunks = [];
                            let url = (window.URL || window.webkitURL).createObjectURL(blob);
                            //this.setPlaybackPreview(url);
                            this.createDownloadLink(url);
                        }

                        this.mediaRecorder.onerror = e => {
                            console.log('Error recording stream');
                            console.log(e.error);
                        }

                        console.log('MediaRecorder ready');
                    }
                );
                resolve(mediaRecorder);
            }
            catch (err) {
                console.log('Error in initializing MediaRecorder of fetching media devices stream')
                reject(err);
            }
        })
    }

    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {onClick, onChange, style, type, accept, capture} = this.props;

        return (

            <label
                onClick={onClick}
                onChange={onChange}

                // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                style={style ? style : {
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: .009
                }}>
                <input type={type} accept={accept} capture={capture}/>
                <video
                    className="recorder"
                    ref={recorderRef => {
                        this.recorderRef = recorderRef
                    }}
                    autoPlay
                    playsinline
                    muted
                />
            </label>

        );
    }


}
